export default function normalizeStateExpression(attribute: string): string {
  return attribute
    .replace(/reduxState\.(globals)/gm, 'globals')
    .replace(/reduxState\.[a-zA-Z\d]+/gm, 'state')
}
